import './facebook-spinner.css';
import React from 'react';

type Props = {
    complete: boolean;
};
export function FacebookSpinner(props: Props) {
    if (props.complete) {
        return null;
    }
    return (
        <div
            style={{
                justifyContent: 'center',
                position: 'absolute',
                left: '50%',
                display: 'flex',
                zIndex: 2,
            }}>
            <div
                style={{
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    borderRadius: '30px',
                    backgroundColor: '#FFFFFF',
                    padding: '16px 12px 12px 12px',
                    boxShadow: '0 12px 28px 0 rgba(0, 0, 0, 0.2),0 2px 4px 0 rgba(0, 0, 0, 0.1)',
                }}>
                <span className="facebook-spinner_svg-wrapper" dir="auto">
                    <svg className="facebook-spinner_svg" height="32" viewBox="0 0 32 32" width="32" role="progressbar">
                        <circle
                            className="facebook-spinner_circle"
                            cx="16"
                            cy="16"
                            fill="none"
                            r="15"
                            stroke="rgb(24, 118, 242)"
                            strokeDasharray="94.24777960769379"
                            strokeWidth="2"></circle>
                    </svg>
                </span>
            </div>
        </div>
    );
}
